import React from 'react';
import Navigation from '../components/Navigation';
import ROHero from '../components/ROHero';
import ROAbout from '../components/ROAbout';
import ROServices from '../components/ROServices';
import Features from '../components/Features';
import Benefits from '../components/Benefits';
import Testimonials from '../components/Testimonials';
import Owner from '../components/Owner';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import FloatingButtons from '../components/FloatingButtons';

const ROPage = () => {
  return (
    <div className="ROPage">
      <Navigation />
      <ROHero />
      <ROAbout />
      <ROServices />
      <Features />
      <Benefits />
      <Testimonials />
      <Owner />
      <Contact />
      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default ROPage;

